export enum OktaUserLoginType {
  EMAIL = 'email',
  USERNAME = 'username',
}
